/* eslint-disable @typescript-eslint/indent */
import { Form } from 'antd'
import { type FormInstance } from 'antd/lib'
import react from 'react'

import { EFormEntityType, type TApplication } from '@/interfaces'
import { ApplicationsState, FormState } from '@/state'
import { formStateActions } from '@/state/actions'

interface FormInstanceResult {
  currentForm: FormInstance
}
export const useFormInstance = (): FormInstanceResult => {
  const [currentForm] = Form.useForm()

  react.useEffect(() => {
    const currentEntityName = FormState.currentEntity.value?.name
    const currentApplicationValues = ApplicationsState.currentApplication.value
    const currentEntityType = FormState.currentEntity.value?.type

    if (
      currentEntityName &&
      currentApplicationValues &&
      currentEntityType === EFormEntityType.SIMPLE
    ) {
      const currentEntityValues: TApplication =
        (currentApplicationValues[currentEntityName] as TApplication) ?? {}

      currentForm.setFieldsValue({
        ...currentEntityValues,
      })

      FormState.currentFormValues.value = { ...currentEntityValues }
    }
  }, [FormState.currentEntity.value?.name])

  react.useEffect(() => {
    formStateActions.setCurrentFormInstance(currentForm)

    return () => {
      currentForm.resetFields()
      formStateActions.setCurrentFormInstance(null)
    }
  }, [])

  return {
    currentForm,
  }
}
